// Política de senhas do Quality (definida com o Alexandre em 12/10/2026).
// A mesma regra é conferida no servidor em api/_senha.js — mantenha os dois iguais.

// Símbolos do teclado (ASCII). Acento, "ç" e espaço não contam — é a mesma regra
// configurada no Supabase (GOTRUE_PASSWORD_REQUIRED_CHARACTERS).
const SIMBOLO = /[!-/:-@[-`{-~]/;

export const REGRAS_SENHA = [
  { id: 'tamanho',   texto: 'Pelo menos 8 caracteres',          ok: s => s.length >= 8 },
  { id: 'maiuscula', texto: 'Uma letra maiúscula (A-Z)',        ok: s => /[A-Z]/.test(s) },
  { id: 'minuscula', texto: 'Uma letra minúscula (a-z)',        ok: s => /[a-z]/.test(s) },
  { id: 'numero',    texto: 'Um número (0-9)',                  ok: s => /[0-9]/.test(s) },
  { id: 'especial',  texto: 'Um caractere especial (! @ # $ …)', ok: s => SIMBOLO.test(s) },
];

export const senhaForte = s => REGRAS_SENHA.every(r => r.ok(String(s || '')));

// Validade: quem não tem configuração usa 90 dias, contados da última troca ou,
// para quem ainda não trocou pelo sistema novo, a partir do início da política.
export const VALIDADE_PADRAO_DIAS = 90;
export const INICIO_POLITICA = '2026-10-12T00:00:00-03:00';
export const OPCOES_VALIDADE = [
  { valor: 'agora', rotulo: 'Trocar agora' },
  { valor: 30, rotulo: 'A cada 30 dias' },
  { valor: 60, rotulo: 'A cada 60 dias' },
  { valor: 90, rotulo: 'A cada 90 dias (padrão)' },
  { valor: 120, rotulo: 'A cada 120 dias' },
  { valor: 'nunca', rotulo: 'Nunca' },
];

// Quem ainda não trocou pelo sistema novo começa a contar do início da política mais
// 0–29 dias (fixo por e-mail): assim os ~1.500 vencimentos não caem no mesmo dia —
// o plano grátis da Brevo envia só 300 códigos por dia.
function deslocamentoDias(email) {
  let h = 0;
  for (const c of String(email || '').toLowerCase()) h = (h * 31 + c.charCodeAt(0)) >>> 0;
  return h % 30;
}

// data = registro do usuário em users. Retorna { vencida, motivo, dias, venceEm, trocadaEm }
export function situacaoSenha(data) {
  const s = data?.senha || {};
  const trocadaEm = s.trocadaEm || null;
  if (s.trocarAgora) return { vencida: true, motivo: 'agora', dias: s.validadeDias ?? VALIDADE_PADRAO_DIAS, venceEm: null, trocadaEm };
  const dias = s.validadeDias === undefined ? VALIDADE_PADRAO_DIAS : s.validadeDias;
  if (!dias) return { vencida: false, motivo: null, dias: null, venceEm: null, trocadaEm };
  const inicio = trocadaEm
    ? new Date(trocadaEm).getTime()
    : new Date(INICIO_POLITICA).getTime() + deslocamentoDias(data?.email) * 86400000;
  const venceEm = new Date(inicio + dias * 86400000);
  return { vencida: Date.now() >= venceEm.getTime(), motivo: 'prazo', dias, venceEm, trocadaEm };
}
